module.exports = __webpack_public_path__ + "img/revista-madrigal-02-sold-out.4b7e2b70.jpg";